import { Component, OnInit, Input, SimpleChanges, OnDestroy, ViewChild } from '@angular/core';
import { CommunicationService } from '../shared/services/communication.service';
import { CallModel } from '../shared/models/calllog.model';
import { CallLogService } from '../shared/services/calllog.service';
import { ClientModel } from '../shared/models/client.model';
import { CallLogModel } from '../shared/models/calllog.model';
//import { ToastrService } from 'ngx-toastr';
import { UserService } from '../shared/services/user.service';
import { Subscription } from 'rxjs';
import { MatHorizontalStepper, MatStep } from '@angular/material';
import { FindCustomerStepComponent } from './find-customer-step/find-customer-step.component';
import { CanComponentLeave } from '../auth/auth.guard';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-techsupport',
  templateUrl: './techsupport.component.html',
  styleUrls: ['./techsupport.component.css']
})
export class TechSupportComponent implements OnInit, OnDestroy, CanComponentLeave{
  //@Input() inputData : string;
  //receiveMessage : string;
 // @Input() stepper : MatHorizontalStepper;
  //@Input() firststep : MatStep;
  @ViewChild('stepper', {static: false}) stepper : MatHorizontalStepper;
  @ViewChild('customerstep', {static: false}) firststep : MatStep;
  @ViewChild('issuestep', {static: false}) secondstep : MatStep;
  @ViewChild('finishstep', {static: false}) thirdstep : MatStep;
  @ViewChild('customerchild', {static: false}) firstchild: FindCustomerStepComponent;

  call : CallModel;
  calllog : CallLogModel;
  commSubsription: Subscription;

  constructor(private commservice : CommunicationService, private callservice : CallLogService,
    private userservice : UserService,
    //private toastr : ToastrService
    private gnotify : GlobalNotification
    ) {

  }

    canLeave() : boolean{
      console.log("canLeave");
    if(this.call && !this.call.isEnd){

      return window.confirm("The current call does not end yet. Are you sure to leave this page?");
    }

    return true;

  }

  ngOnInit() {
    this.commservice.sendTag(true);
  }

  ngOnDestroy()
  {
    console.log("ngOnDestroy : TechSupportComponent ");
    if( this.commSubsription) {
      this.commSubsription.unsubscribe();
      this.commSubsription = null;
    }
  }
  public onStepChange(event: any): void {
    console.log(event.selectedIndex);

    if(this.call == null) return;

    this.call.isLastStep = (event.selectedIndex == 2);
  }

// Output functions
afterEndCall(data : any)
{
  if(this.stepper.selectedIndex == 0)
  {
    this.stepper.next();
    if(!this.secondstep.completed)
    {
      this.secondstep.completed = true;
    }
    this.stepper.next();
  }
  else if(this.stepper.selectedIndex == 1)
  {
    if(!this.secondstep.completed)
    {
      this.secondstep.completed = true;
    }
    this.stepper.next();
  }
}

afterNextFirstStep(data : any)
{
  console.log("afterNextFirstStep ...");

  if(this.calllog == null)
  {
      console.log("insertData ...");
      this.calllog = new CallLogModel();
      this.calllog.clientId = data.client.clientId;
      this.calllog.clientType = data.clientType;
      this.calllog.destination = data.destination;

      this.callservice.insertData(this.calllog).subscribe(
      res=>{
        console.log(res);
        this.calllog = res as CallLogModel;
        console.log("callid = " +  this.calllog.callId);
        this.call = data;
        this.call.callLog = this.calllog;
        this.call.isLastStep = false;
      },
      err =>{
        console.log(err);
        ////this.toastr.error(err, "Call log failed");
        this.gnotify.showSnackBar('Call log failed', err, "error");
      }
      );
  }
  else
  {
      console.log("updateData ...");
      this.calllog.clientId = data.client.clientId;
      this.callservice.updateData(this.calllog).subscribe(
        res=>{
          console.log(res);
          this.call.client = data.client;
          this.call.callLog = this.calllog;
        },
        err =>{
          console.log(err);
          ////this.toastr.error(err, "Call log failed");
          this.gnotify.showSnackBar('Call log failed', err, "error");
        }
      );
   }


  this.firststep.completed = true;
  this.stepper.next();
}

afterNextSecondStep(data : any){
  console.log("afterNextSecondStep ...");
  // this.commservice.sendTag(false);
   this.secondstep.completed = true;
   this.stepper.next();
}

afterBackSecondStep(data : any){
  this.secondstep.completed = false;
  this.stepper.previous();
}

afterFinishStep(data : any){

  console.log("afterFinishStep ...");
  if(data.issue) this.calllog.issueId = data.issue.issueId;
  this.calllog.note = data.callLog.note;

  this.callservice.endCall(this.calllog).subscribe(
    res=>{
      console.log(res);
      this.call = null;
      this.calllog = null;

      this.thirdstep.completed = true;
      this.stepper.reset();

      this.firstchild.resetPage();
    },
    err =>{
      console.log(err);
      ////this.toastr.error(err, "Call log failed");
      this.gnotify.showSnackBar('Call log failed', err, "error");
    }
 );

}

afterBackThirdStep(data : any){
  this.thirdstep.completed = false;
  this.stepper.previous();
}

}
